import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef } from 'react'

//partials
import Filter from './Filter'
import Table from './Table'
import AddOrEdit from './AddOrEdit'
import { useHistory, useLocation } from 'react-router-dom'
import Api from '../../../../_helpers/Api'
import Pagination from '../../../Pagination'
import Question from '../../../modals/messages/Question'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import Skeleton from 'react-loading-skeleton'
import { trans } from '../../../../_providers/Translation'
import popupDefaultHeadImage from "@/assets/img/modals/icons/head.svg"

let timeout

function Index(props, ref) {

    const history = useHistory()
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)

    const modalRef = useRef(null)
    const deleteModalRef = useRef(null)

    const tabs = ['team', 'advert']

    const [state, setState] = useState({
        loading: true,
        data: [],
        total: 0,
        pages: 0,
        page: 1,
        filter: {},
        setFilter: false,
        update: false,
        previewOpen: false,
        previewMessage: null,
        duplicateMessage: null,
    })

    const duplicateModalRef = useRef(null)

    useImperativeHandle(ref, () => ({
        add: () => {
            handleAdd()
        }
    }))

    useEffect(() => {

        let status = props.status || searchParams.get('status')

        setState(prev => ({
            ...prev,
            page: searchParams.get('page') || 1,
            filter: {
                ...prev.filter,
                status: tabs.indexOf(status) > -1 ? status : tabs[0],
                method: searchParams.get('method') || '',
                date: searchParams.get('date') || '',
                deadline: searchParams.get('deadline') || '',
                text: searchParams.get('text') || '',
            },
            update: new Date().getTime()
        }))

    }, [location.search])

    useEffect(() => {
        if (state.setFilter) {
            searchParams.set('page', state.page)

            Object.entries(state.filter).map(filter => {
                // if (filter[1]) {
                searchParams.set(filter[0], filter[1])
                // }
            })

            history.push('?' + searchParams.toString())
        }

    }, [state.setFilter])

    useEffect(() => {
        if (state.update) {
            loadData()
        }
    }, [state.update])


    const loadData = () => {

        setState(prev => ({
            ...prev,
            loading: true
        }))

        let url = 'text-messages/get?type=' + state.filter.status + '&page=' + state.page

        Object.entries(state.filter).map(filter => {
            url += '&' + filter[0] + '=' + filter[1]
        })

        Api.get(url)
            .then(res => {
                setState(prev => ({
                    ...prev,
                    loading: false,
                    data: res.data.items,
                    total: res.data.total,
                    pages: res.data.pages
                }))
            }).catch(err => {
                setState(prev => ({
                    ...prev,
                    loading: false
                }))
            })
    }

    const handleAdd = () => {
        modalRef.current.add(state.filter.status)
    }


    const handleCreate = data => {
        refreshData()
    }

    // edit
    const handleEdit = id => {
        modalRef.current.edit(id)
    }

    // update
    const handleUpdate = newData => {
        refreshData()
    }

    // preview
    const handlePreview = id => {
        const msg = state.data.find(m => m.id === id)
        setState(prev => ({
            ...prev,
            previewOpen: true,
            previewMessage: msg || null
        }))
    }

    const handleClosePreview = () => {
        setState(prev => ({
            ...prev,
            previewOpen: false,
            previewMessage: null
        }))
    }

    // duplicate
    const handleDuplicate = id => {
        const msg = state.data.find(m => m.id === id)
        if (msg) {
            setState(prev => ({
                ...prev,
                duplicateMessage: msg
            }))
            duplicateModalRef.current.open(id)
            duplicateModalRef.current.onSuccess(() => {
                Api.post('text-messages/duplicate', { id: msg.id })
                    .then(res => {
                        setState(prev => ({
                            ...prev,
                            duplicateMessage: null
                        }))
                        refreshData()
                    })
            })
            duplicateModalRef.current.onClose(() => {
                setState(prev => ({
                    ...prev,
                    duplicateMessage: null
                }))
            })
        }
    }

    // send 
    const handleSend = id => {
        modalRef.current.edit(id, { customHeading: true })
    }

    const handleSendMessage = () => {
        refreshData()
    }

    // delete
    const handleDelete = id => {

        deleteModalRef.current.open(id)

        deleteModalRef.current.onSuccess(() => {
            handleDestroy(id)
        })
    }

    const handleDestroy = id => {
        Api.post('text-messages/delete', {
            id: id
        }).then(res => {
            if (res.data.success) {
                let data = state.data.filter(i => {
                    return i.id !== id
                })
                setState(prev => ({
                    ...prev,
                    data: data
                }))
            }
        })
    }

    const handleSearch = (key, val, interval = 300) => {
        clearTimeout(timeout)

        setState(prev => ({
            ...prev,
            filter: {
                ...prev.filter,
                [key]: val,
            },
            page: 1,
        }))

        timeout = setTimeout(() => {
            setState(prev => ({
                ...prev,
                setFilter: new Date().getTime()
            }))
        }, interval)

    }

    const handlePage = page => {
        setState(prev => ({ ...prev, page: page.selected + 1, setFilter: new Date().getTime() }))
    }

    const refreshData = () => {
        setState(prev => ({
            ...prev,
            update: new Date().getTime()
        }))
    }

    return (
        <>
            <AddOrEdit
                ref={modalRef}
                handleCreate={handleCreate}
                handleUpdate={handleUpdate}
                handleSendMessage={handleSendMessage}
            />

            <Question
                ref={deleteModalRef}
                mainMessage={trans('headings.confirmDelete')}
                secondaryMessage={trans('subheadings.confirmDelete')}
            />
            <Question
                ref={duplicateModalRef}
                mainMessage={trans('headings.confirmDuplicate')}
                secondaryMessage={trans('subheadings.confirmDuplicate')}
                confirmText={trans('buttons.duplicate')}
                cancelText={trans('buttons.cancel')}
            />

            {/* Preview Modal using Material-UI Dialog */}
            <div className={`${state.previewOpen ? 'visible' : ''} overlay`}>
                <div className={`${state.previewOpen ? 'show' : ''} popup-primary medium`}>
                    <div className='head-new'>
                        <img src={popupDefaultHeadImage} alt="icon" />
                        <div className='texts'>
                            <h2>
                                {trans('headings.previewMessage')}
                            </h2>
                            <p>{trans('subheadings.previewMessage')}</p>
                        </div>
                        <span className='close' onClick={handleClosePreview}>

                        </span>
                    </div>

                    <div className='body'>
                        {state.previewMessage ? (
                            <div style={{ padding: 4 }}>
                                <div style={{ marginBottom: 12 }}>
                                    <b>{trans('labels.heading')}</b>: {state.previewMessage.subject}
                                </div>
                                <div style={{ marginBottom: 12 }}>
                                    <b>{trans('labels.content')}</b>:<br />
                                    <div style={{ background: '#fafbfc', border: '1px solid #eee', borderRadius: 6, padding: 12, marginTop: 4 }}>
                                        {state.previewMessage.text}
                                    </div>
                                </div>
                                <div style={{ marginBottom: 12 }}>
                                    <b>{trans('labels.receivers')}</b>: {state.previewMessage.receivers_count}
                                </div>
                                <div style={{ marginBottom: 12 }}>
                                    <b>{trans('labels.dateSent')}</b>: {state.previewMessage.send_at_dmy}
                                </div>
                            </div>
                        ) : (
                            <div style={{ padding: 16 }}>{trans('labels.noDataFound')}</div>
                        )}
                    </div>

                    <div className="footer align-right">
                        <button className="button" onClick={handleClosePreview}>
                            {trans('buttons.cancel')}
                        </button>
                    </div>
                </div>
            </div>
            <h3>
                {`${props.name} (${state.total})`}
            </h3>
            <Filter
                data={state.filter}
                handleSearch={handleSearch}
            />
            <hr />

            {
                state.loading
                    ?
                    <Skeleton count={10} height={45} />
                    :
                    <>
                        <Table
                            data={state.data}
                            loading={state.loading}
                            handleEdit={handleEdit}
                            handleDelete={handleDelete}
                            refreshData={refreshData}
                            handlePreview={handlePreview}
                            handleDuplicate={handleDuplicate}
                            handleSend={handleSend}
                        />

                        <Pagination
                            pages={state.pages}
                            page={state.page}
                            handlePage={handlePage}
                        />

                    </>
            }
        </>
    )
}

export default forwardRef(Index)